import React from 'react';
import { FileText, Files, Plus, Settings, Tags, UserRoundCog } from 'lucide-react';
import { ToolTipCommonComponent } from '../../common/CommonComponents';
import { CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS } from '../agency-data/AgencyWorkforceClientTooltips';

interface WorkforceHeaderActionButtonsProps {
  readonly isMobile: boolean;
  readonly onInviteNewWorker: () => void;
  readonly onManageWorkerTypes: () => void;
  readonly onManageWorkerFileTypes: () => void;
  readonly onManageAttributes: () => void;
  readonly onWorkforceNotices: () => void;
  readonly onOnboardingTemplates: () => void;
  readonly onViewShiftConfigs: () => void;
}

const desktopButtonStyle: React.CSSProperties = {
  height: '40px',
  width: 'auto',
  fontSize: '13.5px',
  paddingLeft: '15px',
  paddingRight: '15px',
};

const WorkforceHeaderActionButtons = ({
  isMobile,
  onInviteNewWorker,
  onManageWorkerTypes,
  onManageWorkerFileTypes,
  onManageAttributes,
  onWorkforceNotices,
  onOnboardingTemplates,
  onViewShiftConfigs,
}: WorkforceHeaderActionButtonsProps): React.ReactElement => {
  if (isMobile) {
    return (
      <>
        <div className="payments-header-seconday-button-holder-mobile" style={{ width: '100%' }}>
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.inviteNewWorker}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onInviteNewWorker}
            >
              <Plus size={15} /> Invite New Worker
            </button>
          </ToolTipCommonComponent>
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageWorkerTypes}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onManageWorkerTypes}
            >
              <UserRoundCog size={15} />
              Manage Worker Types
            </button>
          </ToolTipCommonComponent>
        </div>
        <div
          className="payments-header-seconday-button-holder-mobile"
          style={{ width: '100%', marginTop: '10px' }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageWorkerFileTypes}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onManageWorkerFileTypes}
            >
              <Files size={15} />
              Manage Worker File Types
            </button>
          </ToolTipCommonComponent>
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageAttributes}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onManageAttributes}
            >
              <Tags size={15} />
              Manage Attributes
            </button>
          </ToolTipCommonComponent>
        </div>
        <div
          className="payments-header-seconday-button-holder-mobile"
          style={{ width: '100%', marginTop: '10px' }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.workforceNotices}
          >
            <button
              type="button"
              style={{ width: '100%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onWorkforceNotices}
            >
              <FileText size={15} />
              Workforce Notices
            </button>
          </ToolTipCommonComponent>
        </div>
        <div
          className="payments-header-seconday-button-holder-mobile"
          style={{ width: '100%', marginTop: '10px' }}
        >
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.onboardingTemplates}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onOnboardingTemplates}
            >
              <FileText size={15} />
              Onboarding Templates
            </button>
          </ToolTipCommonComponent>
          <ToolTipCommonComponent
            toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.viewShiftConfigs}
          >
            <button
              type="button"
              style={{ width: '50%' }}
              className="payments-header-seconday-button-mobile"
              onClick={onViewShiftConfigs}
            >
              <Settings size={15} />
              View Shift Configs
            </button>
          </ToolTipCommonComponent>
        </div>
      </>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.inviteNewWorker}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onInviteNewWorker}
        >
          <Plus size={16} /> Invite New Worker
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageWorkerTypes}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onManageWorkerTypes}
        >
          <UserRoundCog size={16} />
          Manage Worker Types
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageWorkerFileTypes}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onManageWorkerFileTypes}
        >
          <Files size={16} />
          Manage Worker File Types
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.manageAttributes}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onManageAttributes}
        >
          <Tags size={16} />
          Manage Attributes
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.workforceNotices}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onWorkforceNotices}
        >
          <FileText size={16} />
          Workforce Notices
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.onboardingTemplates}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onOnboardingTemplates}
        >
          <FileText size={16} />
          Onboarding Templates
        </button>
      </ToolTipCommonComponent>
      <ToolTipCommonComponent
        toolTipText={CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS.viewShiftConfigs}
      >
        <button
          type="button"
          className="worky-actions-btn-v2"
          style={desktopButtonStyle}
          onClick={onViewShiftConfigs}
        >
          <Settings size={16} />
          View Shift Configs
        </button>
      </ToolTipCommonComponent>
    </div>
  );
};

export { WorkforceHeaderActionButtons };
